/* unplugin-vue-components disabled */import { ElButton as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/button/style/css';
import { ElTag as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/tag/style/css';
import { ElDropdown as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/dropdown/style/css';
import { ElDropdownMenu as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/dropdown-menu/style/css';
import { ElDropdownItem as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/dropdown-item/style/css';
import { ElIcon as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/icon/style/css';
import { ElInput as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/input/style/css';
import { ElTooltip as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/tooltip/style/css';
import _asyncToGenerator from "D:/hjj/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "home_top_box"
};
var _hoisted_2 = {
  class: "homeTop"
};
var _hoisted_3 = {
  class: "sayhi",
  style: {
    "font-weight": "bold"
  }
};
var _hoisted_4 = {
  class: "entrance"
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "el-dropdown-link"
};
var _hoisted_7 = {
  class: "com-tab-box"
};
import { useUserStore } from "@/store/user";
import { ref, nextTick } from "vue";
import { useRouter, useRoute } from "vue-router";
import { Search, Delete } from "@element-plus/icons-vue";
import { useTimStore } from "@/store/tim";
import { usecommonStore } from "@/store/common";
import { ElMessage, ElMessageBox } from "element-plus";
export default {
  __name: 'homeTop',
  setup(__props) {
    var commonStore = usecommonStore();
    var TimsTore = useTimStore();
    var router = useRouter();
    var route = useRoute();
    var userStore = useUserStore();
    var search_val = ref("");
    var handleClose = tag => {
      commonStore.DEL_ACTIVE_TAGS(tag.code);
      if (!commonStore.activeTags || !commonStore.activeTags[0]) {
        router.push("/home");
      }
      if (route.path == tag.path) {
        router.go(-1);
      }
    };
    var handleChangeSystem = () => {
      var url = "https://www.bio-cloud.com.cn";
      // 根据是正式还是测试环境区分跳转路由
      url = process.env.NODE_ENV === "development" ? url + ":8115" : url + ":8113";
      window.open(url);
    };
    var handleCommand = obj => {
      if (obj.type == "loginout") {
        localStorage.removeItem("token_blk");
        localStorage.removeItem("homeTabs");
        commonStore.CLEAR_ACTIVE_TAGS();
        userStore.clear_userInfo();
        userStore.email_pwd = true;
        // 退出登录
        TimsTore.TIMLoginOut();
        router.push("/login");
      } else if (obj.type == "userCenter") {
        console.log("个人资料");
        router.push("/user_center");
      }
    };
    var handle_open = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* () {
        commonStore.set_activenews("blknews");
        if (!router.currentRoute.value.fullPath != "instant_messages") {
          router.push("/instant_messages");
        }
      });
      return function handle_open() {
        return _ref.apply(this, arguments);
      };
    }();
    var tabBoxRef = ref(null);
    var tabRefs = ref([]);

    // 设置标签页引用
    var setTabRef = (el, index) => {
      if (el) {
        tabRefs.value[index] = el.$el || el;
      }
    };

    // 滚动到激活的标签页
    var scrollToActiveTab = () => {
      nextTick(() => {
        var activeTabIndex = tabs.value.findIndex(isActiveTab);
        if (activeTabIndex !== -1 && tabRefs.value[activeTabIndex]) {
          var tabElement = tabRefs.value[activeTabIndex];
          var container = tabBoxRef.value;
          if (tabElement && container) {
            var tabLeft = tabElement.offsetLeft;
            var tabWidth = tabElement.offsetWidth;
            var containerScrollLeft = container.scrollLeft;
            var containerWidth = container.offsetWidth;

            // 检查标签页是否在可视范围内
            if (tabLeft < containerScrollLeft) {
              // 标签页在左侧不可见区域
              container.scrollTo({
                left: tabLeft,
                behavior: "smooth"
              });
            } else if (tabLeft + tabWidth > containerScrollLeft + containerWidth) {
              // 标签页在右侧不可见区域
              container.scrollTo({
                left: tabLeft + tabWidth - containerWidth,
                behavior: "smooth"
              });
            }
          }
        }
      });
    };
    var tabs = ref(JSON.parse(localStorage.getItem("homeTabs")) || []);
    var isActiveTab = tab => {
      return route.fullPath === tab.fullPath;
    };
    var saveTabsToLocalStorage = () => {
      localStorage.setItem("homeTabs", JSON.stringify(tabs.value));
    };

    // 添加标签页的方法
    var addTab = function addTab(tab) {
      var shouldReplace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      // 检查是否已达到最大标签数
      if (tabs.value.length >= 30) {
        ElMessage.warning("最多只能添加30个标签页，请先关闭部分标签页");
        return;
      }
      var existingIndex = tabs.value.findIndex(t => t.fullPath === tab.fullPath);

      // 如果完全相同，则不重复添加
      if (existingIndex !== -1) {
        return;
      }
      if (shouldReplace && tabs.value.length > 0) {
        // 替换当前活跃的标签页而不是添加新标签页
        var activeTabIndex = tabs.value.findIndex(isActiveTab);
        if (activeTabIndex !== -1) {
          tabs.value.splice(activeTabIndex, 1, {
            title: tab.title,
            path: tab.path,
            fullPath: tab.fullPath
          });
        } else {
          tabs.value.push({
            title: tab.title,
            path: tab.path,
            fullPath: tab.fullPath
          });
        }
      } else {
        tabs.value.push({
          title: tab.title,
          path: tab.path,
          fullPath: tab.fullPath
        });
      }
      saveTabsToLocalStorage();
    };

    // 监听tabs变化并保存到localStorage
    watch(tabs, () => {
      saveTabsToLocalStorage();
      scrollToActiveTab();
    }, {
      deep: true
    });

    // 检查是否应该替换标签页而不是添加新标签页
    var checkShouldReplaceTab = (oldPath, newPath) => {
      // 检查是否是父子路由关系
      if (oldPath && newPath && oldPath !== newPath) {
        if (oldPath.startsWith("/email") && newPath.startsWith("/email/")) {
          return true;
        }
      }
      return false;
    };

    // 监听路由变化
    watch(() => route.fullPath, (newPath, oldPath) => {
      var _route$meta;
      var title = ((_route$meta = route.meta) === null || _route$meta === void 0 ? void 0 : _route$meta.title) || route.name || route.path;

      // 根据路由参数和路由名称判断是新增还是编辑
      if (route.params && route.params.id) {
        // 有id参数，认为是编辑
        if (!title.includes("编辑") && !title.includes("详情")) {
          title += "-编辑";
        }
      } else if (route.query && route.query.id) {
        // 查询参数中有id，也认为是编辑
        if (!title.includes("编辑") && !title.includes("详情")) {
          title += "-编辑";
        }
      } else {
        // 没有id参数，根据路由路径判断页面类型
        var detailRoutes = ["/work_bench/sample_detail", "/work_bench/price_rule_add", "/tripadd"];
        if (detailRoutes.includes(route.path)) {
          // 详情页路由处理
          if (title.includes("样品详情")) {
            title = "申请样品";
          } else if (title.includes("出差申请")) {
            title = "出差申请";
          } else if (!title.includes("新增")) {
            // 如果既不包含详情也不包含编辑，且不包含新增，则添加新增标识
            title += "-新增";
          }
          console.log({
            title
          }, route.path);
        } else {
          // 没有id参数的表单页面，认为是新增
          var formPages = ["合同", "报价", "样品", "物料", "标准品", "客诉", "变更申请", "项目", "任务", "采购", "订单", "申请", "立项", "任务", "会议纪要", "样机管理", "出差"];
          var isFormPage = formPages.some(page => title.includes(page));
          var isNotSpecialPage = !title.includes("列表") && !title.includes("详情") && !title.includes("编辑") && !title.includes("新增");
          if (isFormPage && isNotSpecialPage) {
            title += "-新增";
          }
        }
      }
      if (title.includes("news")) {
        title = "资讯";
      } else if (title.includes("instant_messages")) {
        title = "消息";
      } else if (title.includes("项目管理") && route.path.includes("/pms_analysis")) {
        title = "项目管理";
      } else if (title.includes("样机管理-编辑")) {
        title = "样机管理-详情";
      }

      // 处理父子路由关系，如 /email 和 /email/email_detail/
      var shouldReplaceTab = checkShouldReplaceTab(oldPath, newPath);
      addTab({
        title: title,
        path: route.path,
        fullPath: route.fullPath
      }, shouldReplaceTab);

      // 滚动到激活的标签页
      scrollToActiveTab();
    }, {
      immediate: true
    });
    // 关闭标签页
    var handleCloseTab = index => {
      // 确保至少保留一个标签页
      if (tabs.value.length <= 1) {
        ElMessage.warning("至少要保留一个标签页");
        return;
      }
      var isClosingActiveTab = isActiveTab(tabs.value[index]);
      tabs.value.splice(index, 1);
      saveTabsToLocalStorage();
      if (isClosingActiveTab && tabs.value.length > 0) {
        var targetIndex = index > 0 ? index - 1 : 0;
        if (tabs.value[targetIndex]) {
          router.push(tabs.value[targetIndex].fullPath);
        }
      }
    };
    // 点击标签页切换路由
    var handleTabClick = tab => {
      router.push(tab.fullPath);
    };
    var clearOtherTabs = () => {
      ElMessageBox.confirm("确定要清除其他标签页吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        var activeTabIndex = tabs.value.findIndex(isActiveTab);
        if (activeTabIndex === -1) {
          var _route$meta2;
          tabs.value = [];
          var title = ((_route$meta2 = route.meta) === null || _route$meta2 === void 0 ? void 0 : _route$meta2.title) || route.name || route.path;
          tabs.value.push({
            title: title,
            path: route.path,
            fullPath: route.fullPath
          });
        } else {
          var activeTab = tabs.value[activeTabIndex];
          tabs.value = [activeTab];
        }
        saveTabsToLocalStorage();
        ElMessage.success("已清除其他标签页");
      }).catch(() => {
        // 用户点击取消或关闭弹窗
        ElMessage.info("已取消操作");
      });
    };
    return (_ctx, _cache) => {
      var _unref$info, _unref$info2;
      var _component_el_tooltip = __unplugin_components_0;
      var _component_el_input = __unplugin_components_1;
      var _component_Caret_bottom = _resolveComponent("Caret-bottom");
      var _component_el_icon = __unplugin_components_2;
      var _component_el_dropdown_item = __unplugin_components_3;
      var _component_el_dropdown_menu = __unplugin_components_4;
      var _component_el_dropdown = __unplugin_components_5;
      var _component_el_tag = __unplugin_components_6;
      var _component_el_button = __unplugin_components_7;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, " Hello， " + _toDisplayString((_unref$info = _unref(userStore).info) === null || _unref$info === void 0 ? void 0 : _unref$info.name) + "！ ", 1), _cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "weather",
        style: {
          "margin-right": "auto",
          "padding-left": "50px",
          "z-index": "999"
        }
      }, null, -1)), _createElementVNode("span", _hoisted_4, [_createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        content: "切换Bio-cloud系统",
        placement: "top"
      }, {
        default: _withCtx(() => [_createElementVNode("span", {
          class: "iconfont icon-banbenqiehuan",
          onClick: handleChangeSystem
        })]),
        _: 1
      })]), _createVNode(_component_el_input, {
        modelValue: search_val.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => search_val.value = $event),
        class: "w-50 m-2",
        "prefix-icon": _unref(Search),
        style: {
          "width": "200px"
        }
      }, null, 8, ["modelValue", "prefix-icon"]), _createElementVNode("span", {
        class: "iconfont icon-lingdang",
        onClick: handle_open
      }, [_withDirectives(_createElementVNode("i", null, [_createElementVNode("span", null, _toDisplayString(_unref(userStore).notify_count > 99 ? "99+" : _unref(userStore).notify_count), 1)], 512), [[_vShow, _unref(userStore).notify_count]])]), _createElementVNode("img", {
        src: (_unref$info2 = _unref(userStore).info) === null || _unref$info2 === void 0 ? void 0 : _unref$info2.avatar,
        alt: ""
      }, null, 8, _hoisted_5), _createVNode(_component_el_dropdown, {
        onCommand: handleCommand
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            command: {
              type: 'userCenter'
            }
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("个人中心")])),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            command: {
              type: 'loginout'
            }
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("退出登录")])),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => {
          var _unref$info3;
          return [_createElementVNode("span", _hoisted_6, [_createTextVNode(_toDisplayString((_unref$info3 = _unref(userStore).info) === null || _unref$info3 === void 0 ? void 0 : _unref$info3.name) + " ", 1), _createVNode(_component_el_icon, {
            class: "el-icon--right"
          }, {
            default: _withCtx(() => [_createVNode(_component_Caret_bottom)]),
            _: 1
          })])];
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
        class: "tab-box",
        ref_key: "tabBoxRef",
        ref: tabBoxRef
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab, index) => {
        return _openBlock(), _createBlock(_component_el_tag, {
          key: index,
          closable: tabs.value.length > 1,
          "disable-transitions": false,
          onClose: $event => handleCloseTab(index),
          onClick: $event => handleTabClick(tab),
          class: "tab-item",
          size: "large",
          effect: isActiveTab(tab) ? 'dark' : 'light',
          type: isActiveTab(tab) ? 'primary' : 'info',
          ref_for: true,
          ref: el => setTabRef(el, index)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(tab.title), 1)]),
          _: 2
        }, 1032, ["closable", "onClose", "onClick", "effect", "type"]);
      }), 128))], 512), _createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        content: "清除其他标签页",
        placement: "bottom"
      }, {
        default: _withCtx(() => [tabs.value.length > 1 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          class: "clear-tabs-btn",
          onClick: clearOtherTabs,
          link: "",
          icon: _unref(Delete)
        }, null, 8, ["icon"])) : _createCommentVNode("", true)]),
        _: 1
      })])]);
    };
  }
};